<template>
  <v-card>
    <v-container>
        <v-form v-model="formValid">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="form.firstName"
              :rules="[rules.maxLength(10)]"
              :counter="10"
              label="Název"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.email]"
              label="Login"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="form.password"
              label="Heslo"
              :rules="form.id ? [] : [rules.required, rules.minLength(6)]"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="form.passwordConfirmation"
              :rules="form.id ? [] : [rules.required, formRules.passwordConfirmation]"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
              label="Heslo znovu"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-combobox
              v-model="form.districts"
              :items="cityDistricts"
              :search-input.sync="search"
              hide-selected
              item-text="name"
              item-value="id"
              label="Městské části"
              :rules="[rules.required]"
              multiple
              persistent-hint
              deletable-chips
              small-chips
            >
            </v-combobox>
          </v-col>
          <v-col
            cols="12"
          >
            <v-btn
              :disabled="!formValid || wait"
              color="primary"
              @click="save"
              required
            >Uložit</v-btn>
          </v-col>
        </v-form>
    </v-container>
  </v-card>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  mixins: [rules],
  props: ['item', 'cityDistricts'],
  name: 'AddDriverForm',
  data () {
    return {
      wait: false,
      show1: false,
      show2: false,
      form: {
        id: this.item.id,
        firstName: this.item.firstName,
        email: this.item.email,
        password: '',
        passwordConfirmation: '',
        districts: this.item.districts,
        roleId: 4,
        foodTypes: []
      },
      formValid: true,
      model: ['Vuetify'],
      search: null,
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      }
    }
  },
  methods: {
    save () {
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/users${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(response => {
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 422) {
            alert('E-mail je již používán.')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
